module.exports = __webpack_public_path__ + "81b3452081795c6c054712e6371aa7c1.jpg";